import type { PhrasingContent } from 'mdast';

import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';

import type { FromPMHandlers } from '../types';
import { convertInlineChildren } from '../utils';

export function paragraph(
	node: PMNode,
	handlers: FromPMHandlers,
): { children: PhrasingContent[]; type: 'paragraph' } {
	const children: PhrasingContent[] = convertInlineChildren(node, handlers);
	return { type: 'paragraph' as const, children };
}
